import { PageRenderProvider } from "../../../../misc/pdf/parts/PageContext";
import { Page } from "../../../../misc/pdf/parts/Page";
import { PDFHeader } from "../../../../misc/pdf/parts/PDFHeader";
import { orderByAscending, selectMany } from "nate-react-api-helpers";
import React, { useMemo } from "react";
import { prepsGetCategorySorted } from "../../../project/shopdrawing/extras/preps/PrepUtil";
import { genericDistanceParser, isMetric } from "../../../../misc/scroller/Table";
import { ImperialDistance } from "../../../../misc/ImperialDistance";
import { MetricDistance } from "../../../../misc/MetricDistance";
import { getSpecialtyHingePrepLocation, removeActiveInActiveSuffix } from "../../warehouse/InventoryFrameTable";
import { css } from "@emotion/css";
import clsx from "clsx";
import { grey } from "@mui/material/colors";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DoorDetails(props) { if (props.value.length === 0) {
    setTimeout(() => props.onReady(true), 100);
    return null;
} return /*#__PURE__*/ _jsx(PageRenderProvider, { data: props.value, onReady: props.onReady, children: info => /*#__PURE__*/ _jsx(Page, { orientation: "landscape", children: /*#__PURE__*/ _jsxs("div", { style: { flex: 1, display: "flex", flexDirection: "column", alignItems: "stretch" }, children: [/*#__PURE__*/ _jsx(PDFHeader, { noAddress: true, title: "Door Detail" }), /*#__PURE__*/ _jsx(RenderTable, { config: tableCfg, pageIndex: info.pageIndex, rows: info.rows })] }) }, info.pageIndex.toString()) }, "door-details"); }
export function RenderTable(props) { const rowCount = props.config.reduce((acc, item) => (item.row || 0) > acc ? item.row || 0 : acc, 0) + 1; const rowConfigs = []; for (let i = 0; i < rowCount; i++) {
    rowConfigs.push(props.config.filter(r => (r.row || 0) === i));
} return /*#__PURE__*/ _jsx("table", { className: table2, children: /*#__PURE__*/ _jsxs("tbody", { children: [/*#__PURE__*/ _jsx("tr", { className: "header", children: props.config.filter(r => (r.row || 0) === 0).map((r, index) => /*#__PURE__*/ _jsx("th", { children: r.name }, r.name + "-" + index.toString())) }, "head"), props.rows.map((r, index) => { const nonBlankRows = rowConfigs.filter((rowCfg, index) => { const hasNonBlankCell = rowCfg.filter(col => col.show ? col.show(r, props.rows) : true).map(col => assertIsArray(col.selector(r, "html") || [])).find(v => !!v.find(s => !!s)); return !!hasNonBlankCell; }); return /*#__PURE__*/ _jsx(React.Fragment, { children: nonBlankRows.map((rowCfg, index) => /*#__PURE__*/ _jsx("tr", { className: clsx({ "first-section-row": index === 0, "last-section-row": index === nonBlankRows.length - 1 }), children: rowCfg.map((col, index) => { return /*#__PURE__*/ _jsxs(React.Fragment, { children: [col.indent ? /*#__PURE__*/ _jsx("td", { colSpan: col.indent }) : null, /*#__PURE__*/ _jsx("td", { colSpan: col.colSpan, children: assertIsArray(col.selector(r, "html") || []).map(s => /*#__PURE__*/ _jsx("div", { children: s })) })] }, index); }) }, index.toString())) }, props.pageIndex + "-" + index.toString()); })] }) }); }
export function tableCfgToCsv(tableCfg, items) {
    const rowCount = tableCfg.reduce((acc, item) => (item.row || 0) > acc ? item.row || 0 : acc, 0);
    const rowConfigs = [];
    for (let i = 0; i < rowCount; i++) {
        rowConfigs.push(tableCfg.filter(r => (r.row || 0) === i));
    }
    let csvRows = [];
    items.map((r, index) => {
        rowConfigs.filter((rowCfg, index) => { const hasNonBlankCell = rowCfg.filter(col => col.show ? col.show(r, items) : true).map(col => assertIsArray(col.selector(r, "string") || [])).find(v => !!v.find(s => !!s)); return !!hasNonBlankCell; }).forEach(rowCfg => {
            let row = []; // setup header
            if (csvRows.length === 0) {
                csvRows.push(tableCfg.map(col => col.name));
            }
            rowCfg.map((col, index) => { if (col.indent) {
                row.push(...Array(col.indent).fill(""));
            } row.push(col.selector(r, "string").join(", ")); if (col.colSpan) {
                row.push(...Array(col.colSpan - 1).fill(""));
            } });
            csvRows.push(row);
        });
    });
    return csvRows;
}
export const table2 = css({ border: "1px solid transparent", borderCollapse: "collapse", fontSize: "0.8rem", minWidth: 300, "& td, & th": { paddingLeft: 2, paddingRight: 2, textAlign: "left" }, "& .last-section-row td": { borderBottom: "1px dotted " + grey["600"], paddingBottom: 10 }, "& .header th": { borderTop: "1px solid " + grey["800"] }, "& tbody > tr:last-child td": { borderBottom: "1px solid " + grey["800"] } });
export function assertIsArray(value) { if (typeof value !== "object" || !(value instanceof Array)) {
    console.error("value is not array!", value);
    return [];
} return value; }
const tableCfg = [{ name: "Opening", selector: r => [r.name] }, { name: "Qty", selector: r => [r.qty.toString()] }, { name: "Type", selector: r => [r.type] }, { name: "Width", selector: r => [r.purchaseOrderItem.dimWidth] }, { name: "Height", selector: r => [r.purchaseOrderItem.dimHeight] }, { name: "Exact", selector: r => [r.doorExactHeight] }, { name: "Handing", selector: r => [r.purchaseOrderItem.doorHanding] }, { name: "Label", selector: r => [r.purchaseOrderItem.doorLabel] }, { name: "Series", selector: r => [r.purchaseOrderItem.doorSeries] }, { name: "Material", selector: r => [r.purchaseOrderItem.doorMaterial] }, { name: "Gauge", selector: r => [r.purchaseOrderItem.doorGauge] }, { name: "Thickness", selector: r => [r.purchaseOrderItem.doorThickness] }, { name: "Door Elev", selector: r => [r.purchaseOrderItem.doorElevation] }, { name: "Core", selector: r => [r.purchaseOrderItem.doorCore] }, { name: "Seam", selector: r => [r.purchaseOrderItem.doorSeam] }, { name: "Prep Elev", selector: r => [r.hardwarePrepDiagramName] }, { name: "Hw Indent", row: 1, selector: r => [""] }, { name: "Hardware Preps", row: 1, colSpan: 15, selector: (r, format) => makeHardwarePreps(r, "door", format) }, { name: "Wd Indent", row: 2, selector: r => [""] }, { name: "Wood Detail", row: 2, colSpan: 15, selector: (r, format) => makeWoodDetail(r, format) }];
function makeHtmlRow(list, label) { return /*#__PURE__*/ _jsxs("div", { style: { display: "flex", gap: 4 }, children: [label, list.map((l, index) => /*#__PURE__*/ _jsxs("div", { style: { display: "flex" }, children: [l, index + 1 !== list.length ? "," : ""] }))] }); }
export function makeWoodDetail(r, format) { let list = []; const sortedList = []; const raw = []; if (r.doorWoodDetail) {
    const w = r.doorWoodDetail;
    if (w.materialName)
        raw.push(w.materialName);
    if (w.cut)
        raw.push(w.cut);
    if (w.matching)
        raw.push(w.matching);
    if (w.matchingMethod)
        raw.push(w.matchingMethod);
    if (w.ply)
        raw.push(w.ply);
    if (w.finish)
        raw.push(w.finish);
    if (w.swatchName)
        raw.push(w.swatchName);
} raw.forEach(v => { let name = v; if (format === "html") {
    name = /*#__PURE__*/ _jsx("div", { children: name });
} sortedList.push(name); }); if (sortedList.length > 0) {
    if (format === "html") {
        list.push(makeHtmlRow(sortedList));
    }
    else {
        list.push(sortedList.join(", "));
    }
} return list; }
export function makeHardwarePreps(r, kind, format) { let list = []; if (kind === "door") {
    const sortedList = [];
    prepsGetCategorySorted(r.doorHardwarePreps).forEach(v => { if (v.value.type === "standard") {
        let name = v.key;
        if (format === "html") {
            name = /*#__PURE__*/ _jsx("div", { children: name });
        }
        sortedList.push(name);
    }
    else if (v.value.type === "custom") {
        let name = v.value.productName || `<missing name:id=${v.value.product}>`;
        if (v.value.degreesOfOpening) {
            name += ` @ ${v.value.degreesOfOpening}°`;
        }
        if (format === "html") {
            name = /*#__PURE__*/ _jsx("i", { children: name });
        }
        sortedList.push(name);
    } });
    if (sortedList.length > 0) {
        if (format === "html") {
            list.push(makeHtmlRow(sortedList));
        }
        else {
            list.push(sortedList.join(", "));
        }
    }
    const locs = getSpecialtyHingePrepLocation(r.doorHardwarePreps);
    if (locs) {
        list.push(`Specialty Hinge Prep at ${locs.display}`);
    }
    if (list.length === 0) {
        return ["BLANK"];
    }
} if (kind === "frame") {
    let unequal = null;
    const active = [];
    const inactive = [];
    const other = [];
    prepsGetCategorySorted(r.frameHardwarePreps).forEach(v => { if (v.value.type === "standard") {
        let name = removeActiveInActiveSuffix(v.key);
        if (format === "html") {
            name = /*#__PURE__*/ _jsx("span", { children: name });
        }
        const frameSide = v.value.frameSide || "other";
        if (frameSide === "active") {
            active.push(name);
        }
        else if (frameSide === "inactive") {
            inactive.push(name);
        }
        else {
            other.push(name);
        }
    }
    else if (v.value.type === "custom") {
        let name = v.value.productName || "<missing product id:" + v.value.product + ">";
        if (v.value.degreesOfOpening) {
            name += ` @ ${v.value.degreesOfOpening}°`;
        }
        if (format === "html") {
            name = /*#__PURE__*/ _jsx("i", { children: name });
        }
        const frameSide = v.value.frameSide || "other";
        if (frameSide === "active") {
            active.push(name);
        }
        else if (frameSide === "inactive") {
            inactive.push(name);
        }
        else {
            other.push(name);
        }
    }
    else if (v.value.type === "unequalPairDoorSizes") {
        unequal = "Unequal pair (active=" + v.value.activeDoorWidth + ", " + v.value.inactiveDoorWidth + ")";
    } });
    if (unequal) {
        list.push(unequal);
    }
    if (active.length > 0) {
        if (format === "html") {
            list.push(makeHtmlRow(active, /*#__PURE__*/ _jsx("span", { children: "Active side:" })));
        }
        else {
            list.push("Active side: " + active.join(", "));
        }
    }
    if (inactive.length > 0) {
        if (format === "html") {
            list.push(makeHtmlRow(inactive, /*#__PURE__*/ _jsx("span", { children: "Inactive side:" })));
        }
        else {
            list.push("Inactive side: " + inactive.join(", "));
        }
    }
    if (other.length > 0) {
        if (format === "html") {
            list.push(makeHtmlRow(other));
        }
        else {
            list.push(other.join(", "));
        }
    }
    const locs = getSpecialtyHingePrepLocation(r.frameHardwarePreps);
    if (locs) {
        list.push(`Specialty Hinge Prep at ${locs.display}`);
    }
    if (list.length === 0) {
        return ["BLANK"];
    }
} return list; }
export function doorDetailsCSV(items) { return tableCfgToCsv(tableCfg, items); }
export function makeDoorDetails(items) { let hardwareDetail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : []; const dr = selectMany(items.filter(v => v.kind === "door").map(i => { if (!i.openings || i.openings.length === 0) {
    return [{ opening: -i.id, openingSequence: 0, openingLocationTransition: "", openingType: i.frameType, qty: i.qty, name: "", purchaseOrderItem: i, type: i.frameType, doorHardwarePreps: i.doorPreps, doorWoodDetail: i.doorWoodDetail, frameHardwarePreps: {} }];
} return i.openings.map(op => { let name = op.name; if (op.frameProfile === "COM") {
    name = `${op.name} (COM)`;
} if (op.type === "Pair") {
    name = `${op.name} (${op.subType})`;
} const hw = hardwareDetail.find(h => h.openingId === op.id); const exactHeight = getExactHeight(op.nominalHeight, hw); return { opening: op.id, openingSequence: op.seqNumber, openingLocationTransition: op.locationTransition, openingType: op.type, openingSubType: op.subType || "", qty: op.qty, name: name, purchaseOrderItem: i, type: op.type, doorHardwarePreps: op.doorHardwarePreps, doorWoodDetail: i.doorWoodDetail, frameHardwarePreps: {}, nominalHeight: op.nominalHeight, nominalWidth: op.nominalWidth, hardwarePrepDiagramName: (hw === null || hw === void 0 ? void 0 : hw.prepDiagramName) || "", doorExactHeight: exactHeight, frameExactHeight: "" }; }); }), v => v); orderByAscending(dr, v => v.openingSequence); return dr; }
function getExactHeight(nominalHeight, hw) { const fmt = isMetric(nominalHeight) ? MetricDistance.showMM : ImperialDistance.showInches; if (!hw) {
    const ht = genericDistanceParser(nominalHeight).universalValue();
    return fmt(ht - ImperialDistance.parse("7/8\"").universalValue());
} let exact = hw.manager.exactDoorHeight(); return fmt(exact); }
export function useDoorDetails(items, hardware) { return useMemo(() => makeDoorDetails(items, hardware), [items, hardware]); }
